export default {
  common: {
    email: 'ইমেইল',
    phone: 'ফোন',
    phoneNumber: 'ফোন নম্বর',
    countrySelect: 'দেশ বেছে নিন',
    countryUnmodifiedNote: 'রেজিস্ট্রেশনের পর দেশ পরিবর্তন করা যাবে না',
    next: 'পরবর্তী',
    back: 'ফিরে',
    attention: 'মনোযোগ',
    cancel: 'বাতিল করুন',
    confirm: 'নিশ্চিত করুন',
    modify: 'পরিবর্তন করুন',
    ignore: 'উপেক্ষা করুন',
    firstName: 'প্রথম নাম',
    middleName: 'মধ্য নাম',
    lastName: 'পদবি',
    gender: 'লিঙ্গ',
    male: 'পুরুষ',
    female: 'মহিলা',
    birthday: 'জন্মদিন',
    graphicCode: 'গ্রাফিক কোড',
    emailCode: 'ইমেল যাচাইকরণ কোড',
    smsCode: 'এসএমএস কোড',
    smsVerificationCode: 'এসএমএস যাচাইকরণ কোড',
    bind: 'বাঁধন',
    send: 'পাঠান',
    resend: 'আবার পাঠান',
    address: 'ঠিকানা',
    done: 'সম্পন্ন',
    systemMessage: 'সিস্টেম বার্তা',
    setting: 'সেটিং',
    submit: 'জমা দিন',
    language: 'ভাষা',
    edit: 'সম্পাদনা করুন',
    delete: 'মুছে দিন'
  },
  account: {
    account: 'হিসাব',
    nickname: 'ডাকনাম',
    id: 'আইডি',
    basicInfo: 'বেসিক লেভেল',
    placeholder: 'অনুগ্রহ করে প্রবেশ করুন',
    completed: 'সম্পন্ন',
    semiInfo: 'আধা-যাচাইকৃত',
    fullyInfo: 'সম্পূর্ণরূপে যাচাই করা হয়েছে',
    basicTab: 'বেসিক',
    advancedTab: 'অ্যাডভান্সড',
    linkedAccount: 'লিঙ্ক করা উইথড্রয়াল অ্যাকাউন্ট',
    accountSecurity: 'মেটওয়ালেট অ্যাকাউন্ট এবং নিরাপত্তা',
    logout: 'লগ আউট করুন',
    semiToast: 'অনুগ্রহ করে বেসিক-লেভেল যাচাইকরণ সম্পূর্ণ করুন',
    fullyToast: 'অনুগ্রহ করে বেসিক-লেভেল সম্পূর্ণ করুন \n এবং সেমি-ভেরিফাইড',
    quickLoginTitle: 'দ্রুত লগইন',
    cancelQuickLogin: 'আপনি কি দ্রুত লগইন নিষ্ক্রিয় করার বিষয়ে নিশ্চিত?'
  },
  accountSecurity: {
    title: 'অ্যাকাউন্ট এবং নিরাপত্তা',
    payPwd: 'পেমেন্ট পাসওয়ার্ড',
    loginPwd: 'লগইন পাসওয়ার্ড',
    changeEmail: 'ইমেইল পরিবর্তন করুন',
    changePhone: 'ফোন নম্বর পরিবর্তন করুন',
    changePayPwd: 'পেমেন্ট পাসওয়ার্ড পরিবর্তন করুন',
    changeLoginPwd: 'লগইন পাসওয়ার্ড পরিবর্তন করুন',
    bindEmail: 'ইমেল বাঁধুন',
    bindEmailNote: 'এটি আবদ্ধ করতে ইমেল যাচাইকরণ পাস করুন',
    bindEmailPlaceholder: 'আপনি আবদ্ধ করতে চান ইমেল লিখুন',
    smsBindNote: 'এটি আবদ্ধ করতে এসএমএস যাচাইকরণ পাস করুন',
    bindPhone: 'ফোন নম্বর বাঁধুন',
    smsAuthentication: 'এসএমএস প্রমাণীকরণ',
    emailAuthentication: 'ইমেল প্রমাণীকরণ',
    phoneVerificationNote: 'আগে বর্তমান ফোন নম্বর যাচাইকরণ পাস',
    bindPhonePlaceholder: 'আপনি আবদ্ধ করতে চান ফোন নম্বর লিখুন',
    verificationWrongToast: 'আপনার যাচাইকরণ কোড চেক করুন',
    phoneNumberEmptyToast: 'ফোন নম্বর পূরণ করুন',
    verificationCodeEmptyToast: 'কোড পূরণ করুন',
    wrongCodeToast: 'ভুল কোড',
    changeNote: 'এটি পরিবর্তন করতে যাচাইকরণ পাস করুন.',
    newEmailVerification: 'নতুন ইমেল যাচাইকরণ',
    newEmailPlaceholder: 'আপনার নতুন ইমেল লিখুন',
    change: 'পরিবর্তন',
    emailLowercaseToast: 'ইমেল ছোট হাতের অক্ষরে হওয়া উচিত।',
    newEmailEmptyToast: 'নতুন ইমেল পূরণ করুন',
    changeSuccessToast: 'সফলভাবে পরিবর্তন',
    phonePlaceholder: 'ফোন লিখুন',
    currentEmail: 'বর্তমান ইমেল',
    passCurrentEmailVerificationFirst: 'প্রথমে বর্তমান ইমেল যাচাইকরণ পাস করুন',
    currentEmailVerification: 'বর্তমান ইমেল যাচাইকরণ',
    smsVerification: 'এসএমএস যাচাইকরণ',
    currentPhoneNumber: 'বর্তমান ফোন নম্বর',
    currentPhoneVerification: 'বর্তমান ফোন যাচাইকরণ',
    currentEmailAddress: 'বর্তমান ইমেল ঠিকানা',
    phoneVerification: 'ফোন যাচাইকরণ',
    enterVerificationCode: 'যাচাইকরণ কোড লিখুন',
    newPhoneNumber: 'নতুন ফোন নম্বর',
    newEmail: 'নতুন ইমেল'
  },
  withdrawAccount: {
    selectAccountType: 'অ্যাকাউন্টের ধরন নির্বাচন করুন',
    noBasicLevelVerificationDialog:
      'ক্যাশ আউট পদ্ধতি আবদ্ধ করার আগে অনুগ্রহ করে প্রাথমিক স্তরের যাচাইকরণ সম্পূর্ণ করুন।',
    bindNote: 'অনুগ্রহ করে সঠিক অ্যাকাউন্টের তথ্য পূরণ করুন, নতুবা আপনার উত্তোলন প্রভাবিত হবে।',
    bindBankAccount: 'ব্যাঙ্ক অ্যাকাউন্ট বাঁধুন',
    bindMobileMoneyAccount: 'মোবাইল মানি অ্যাকাউন্ট বাঁধুন',
    fieldEmptyToast: '{0} প্রয়োজন৷',
    fieldLengthToast: '{0} তে কমপক্ষে {1}টি অক্ষর থাকতে হবে৷',
    bindBankRepeatToast: 'একই ব্যাঙ্ক অ্যাকাউন্ট বারবার বাঁধবেন না!',
    accountName: 'অ্যাকাউন্টের নাম',
    ifscCode: 'IFSC কোড',
    accountEmptyToast: 'অ্যাকাউন্ট প্রয়োজন',
    accountNameEmptyToast: 'অ্যাকাউন্টের নাম প্রয়োজন',
    phoneEmptyToast: 'ফোন প্রয়োজন',
    emailEmptyToast: 'ইমেল প্রয়োজন',
    ifscCodeEmptyToast: 'IFSC কোড প্রয়োজন',
    ifscCodeLengthToast: 'IFSC কোড 11 সংখ্যার হতে হবে',
    bindIMPSRepeatToast: 'একই IMPS অ্যাকাউন্ট বারবার বাঁধবেন না!',
    bindNote2:
      'অনুগ্রহ করে আপনার সঠিক TRC-20 ঠিকানাটি পূরণ করুন। একটি ভুল ঠিকানা পেমেন্ট হারিয়ে ফেলবে, যার দায় আমরা নেব না।',
    usdtAddress: 'USDT ঠিকানা(TRC-20):',
    minimumLimit: 'প্রতি লেনদেনের জন্য সর্বনিম্ন উত্তোলন: $10',
    usdtFee: 'ফি: প্রকৃত ফি অনুসারে',
    registerGcash: 'আপনার যদি Gcash অ্যাকাউন্ট না থাকে, তাহলে নিবন্ধন করতে এখানে ক্লিক করুন।',
    registerEpay: 'আপনার যদি Epay অ্যাকাউন্ট না থাকে, তাহলে নিবন্ধন করতে এখানে ক্লিক করুন।',
    bindThirdPartyTitle: '{0} অ্যাকাউন্ট বাঁধুন',
    wrongAccountToast: 'ভুল হিসাব',
    accountFormatToast: 'অ্যাকাউন্ট বিন্যাস ভুল',
    bindThirdPartyFailedToast: '{0} বাঁধাই ব্যর্থ হয়েছে৷',
    queryFailedToast: 'ক্যোয়ারী ব্যর্থ হয়েছে৷',
    editFailedToast: 'ব্যর্থ সম্পাদনা.',
    add: 'যোগ করুন',
    confirmEditDialog: 'আপনি কি {0} অ্যাকাউন্ট সম্পাদনা করার বিষয়ে নিশ্চিত?',
    payPwdRequireDialog: 'একটি অ্যাকাউন্ট যোগ করার আগে দয়া করে একটি 6-সংখ্যার পেমেন্ট পাসওয়ার্ড সেট করুন৷',
    unbindFailedToast: 'আনবাইন্ডিং ব্যর্থ হয়েছে৷',
    cashOutSuccessNote: 'আনুমানিক আগমনের সময়: 7 কার্যদিবসের মধ্যে',
    requestSubmitted: 'উত্তোলনের অনুরোধ জমা দেওয়া হয়েছে',
    amountLimitToast1: 'ক্যাশ আউট পরিমাণ ≥$40.00 হতে হবে',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'ক্যাশ আউট পরিমাণ ≥${0}.00 হতে হবে',
    // eslint-disable-next-line no-template-curly-in-string
    recommendAmountNote: 'টিপস: প্রত্যাহার করার আগে ${0} পরিমাণ জমা করা কার্যকরভাবে আপনার প্রসেসিং ফি সংরক্ষণ করবে।',
    amountNotEnoughToast: 'ক্যাশ আউট পরিমাণ যথেষ্ট নয়',
    exceedingLimitToast1: 'নগদ আউট পরিমাণ আজ উচ্চ সীমা পৌঁছেছে',
    exceedingLimitToast2:
      'নগদ আউট পরিমাণ আজ উচ্চ সীমা পৌঁছেছে. সীমা বাড়াতে আপনাকে কি উন্নত সার্টিফিকেশন সম্পূর্ণ করতে হবে?',
    restrictedCountriesPayPalAccountToast:
      'একটি সীমাবদ্ধ দেশ পেপ্যাল ​​অ্যাকাউন্ট ব্যবহার করবেন না, যার কারণে আপনার Arripay ব্লক হয়ে যাবে',
    withdrawMinimumToast: 'প্রতি লেনদেনের জন্য সর্বনিম্ন উত্তোলন: $40',
    bankNotAvailableToast: 'এই ব্যাঙ্কটি আর উপলব্ধ নেই, অনুগ্রহ করে অন্য ব্যাঙ্কগুলিকে আবদ্ধ করুন৷',
    usdtAccountInvalidToast:
      'এই USDT অ্যাকাউন্টটি উত্তোলন করতে অক্ষম, অনুগ্রহ করে তোলার জন্য একটি নতুন অ্যাকাউন্ট ব্যবহার করুন।',
    noPayPwdToast: 'ক্যাশ-আউট করার আগে একটি 6-সংখ্যার পেমেন্ট পাসওয়ার্ড সেট করুন।',
    editBankAccount: 'ব্যাঙ্ক অ্যাকাউন্ট সম্পাদনা করুন',
    accountPlaceholder: 'আপনার অ্যাকাউন্ট লিখুন',
    trc20Placeholder: 'TRC-20 ঠিকানা লিখুন',
    accountRepeatToast: 'বর্তমানের মতো একই।',
    unbindBankCardConfirmDialog: 'আপনি কি ব্যাঙ্ক কার্ড {0} আনবাইন্ড করার বিষয়ে নিশ্চিত?',
    unbindMobileMoneyAccountConfirmDialog: 'আপনি কি মোবাইল মানি অ্যাকাউন্ট {0} আনবাইন্ড করার বিষয়ে নিশ্চিত?',
    unbindAccountConfirmDialog: 'আপনি কি {0} অ্যাকাউন্টটি আনবাইন্ড করার বিষয়ে নিশ্চিত?',
    availableBalance: 'উপলব্ধ ব্যালেন্স {0}',
    estimatedFee: 'আনুমানিক ফি',
    submitFailToast: 'জমা দিতে ব্যর্থ হয়েছে',
    disabledMethodToast: 'এই চ্যানেলটি সাময়িকভাবে অনুপলব্ধ৷',
    channelUnavailableTitle: 'চ্যানেল অনুপলব্ধ',
    channelUnavailableNote: 'এই উত্তোলন চ্যানেলটি সাময়িকভাবে অনুপলব্ধ। অন্য উপায় চেষ্টা করুন।',
    channelUnavailableOk: 'ঠিক আছে',
    bankTransferUnavailableTitle: 'ব্যাংক ট্রান্সফার অনুপলব্ধ',
    bankTransferUnavailableNote:
      'আপনার অ্যাকাউন্টের জন্য ব্যাংক ট্রান্সফার এখন উপলব্ধ নয়। উত্তোলনের জন্য Epay ব্যবহার করুন।',
    channelMaintenanceTitle: 'চ্যানেল রক্ষণাবেক্ষণে আছে',
    channelMaintenanceNote: 'এই উত্তোলন চ্যানেলটি রক্ষণাবেক্ষণে আছে। অন্য উপায় চেষ্টা করুন।',
    bankInfoUpdateTitle: 'আপনার ব্যাংক তথ্য আপডেট করুন',
    bankInfoUpdateNote: 'ব্যাংকের নীতি সমন্বয়ের কারণে, চালিয়ে যেতে আপনার ব্যাংক বিবরণ আপডেট করুন।',
    bindEpay: 'Epay বাইন্ড করুন',
    useEpay: 'Epay ব্যবহার করুন',
    iMPSMaxLimitToast: 'এই চ্যানেলের মাধ্যমে একটি একক লেনদেনের জন্য সর্বাধিক উত্তোলনের পরিমাণ হল $260৷',
    linkedAccount: 'অ্যাকাউন্ট যোগ করা হয়েছে',
    otherAccounts: 'অন্যান্য অ্যাকাউন্ট যোগ করা যেতে পারে',
    withdrawTo: 'ট্রান্সফার করুন',
    withdrawAmount: 'স্থানান্তর পরিমাণ',
    withdrawable: 'প্রত্যাহারযোগ্য',
    documentIdToast: 'আইডি নম্বরে শুধুমাত্র সংখ্যা থাকতে পারে',
    noAvailableMethodNote: 'কোনও উত্তোলন পদ্ধতি উপলব্ধ নেই',
    recommended: 'প্রস্তাবিত'
  },
  paymentCode: {
    changePayPwd: 'পেমেন্ট পাসওয়ার্ড পরিবর্তন করুন',
    setPayPwd: 'পেমেন্ট পাসওয়ার্ড সেট করুন',
    setPayPwdNote: 'অনুগ্রহ করে 6-সংখ্যার পেমেন্ট পাসওয়ার্ড সেট করুন',
    reenterPayPwdNote: 'আবার প্রবেশ করুন',
    verificationNote: 'এটি সেট করতে দয়া করে যাচাই পাস করুন৷',
    emailVerification: 'ইমেল যাচাইকরণ',
    inconsistentPasswordToast: 'অসামঞ্জস্যপূর্ণ পাসওয়ার্ড',
    payPwdNote: 'পেমেন্ট পাসওয়ার্ড লিখুন',
    payPwdFormatToast: 'পেমেন্ট পাসওয়ার্ড একটি 6-সংখ্যার নম্বর',
    payPwdWrongToast: 'ভুল পেমেন্ট পাসওয়ার্ড',
    payPwdVerificationFailToast: 'পেমেন্ট পাসওয়ার্ড যাচাই ব্যর্থ হয়েছে!',
    successToast: 'সফলভাবে \n সেট করুন৷'
  },
  authorize: {
    requirement:
      'আপনার জন্য সম্পর্কিত পরিষেবা প্রদানের জন্য {0} আপনার MetWallet এর নিম্নলিখিত তথ্য অর্জন করতে হবে{1}৷ ডাকনাম, অবতার, লিঙ্গ ইত্যাদি।',
    authorize: 'অনুমোদন করুন',
    switchAccount: 'অ্যাকাউন্ট পরিবর্তন করুন',
    goToMetWallet: 'MetWallet এ যান',
    notMatchTips:
      'অপারেশন ব্যর্থ হয়েছে. আপনি শুধুমাত্র আপনার আবদ্ধ MetWallet অ্যাকাউন্ট দিয়ে দ্রুত লগইন সক্ষম করতে পারেন'
  },
  basicLevel: {
    namePlaceholder: 'কোন চিহ্ন, সংখ্যা নেই',
    verification: 'যাচাইকরণ',
    whatsAvailable: 'কি পাওয়া যায়',
    cashOut: 'ক্যাশ আউট',
    withdrawLimit: 'প্রতিদিন $50',
    basicLevelNote: 'আপনার আসল ব্যক্তিগত তথ্য প্রবেশ করান। ভুল তথ্য উত্তোলন ব্যর্থ হতে পারে।',
    fieldEmptyToast: 'সমস্ত প্রয়োজনীয় ক্ষেত্র পূরণ করুন.',
    successToast: 'সফলভাবে \n সংরক্ষিত',
    failToast: 'সংরক্ষণ ব্যর্থ হয়েছে',
    confirmDialog: 'আপনার আসল ব্যক্তিগত তথ্য প্রবেশ করান। ভুল তথ্য উত্তোলন ব্যর্থ হতে পারে।',
    birthdayFormatToast: 'ভুল জন্মদিন ক্ষেত্রের বিন্যাস',
    verificationCodeError: 'যাচাইকরণ কোড ত্রুটি',
    verificationCodeEmpty: 'যাচাইকরণ কোড খালি',
    noEmailCodeToast: 'অনুগ্রহ করে ইমেল যাচাইকরণ কোড পান',
    checkDialogTitle: 'আপনার তথ্য পরীক্ষা করুন',
    checkDialogContent: 'সফলভাবে উত্তোলন করতে, আপনার তথ্য পরীক্ষা করুন। ভুল তথ্য উত্তোলন ব্যর্থ হতে পারে।',
    check: 'পরীক্ষা'
  },
  semiVerified: {
    uploadPhotoId: 'ফটো আইডি আপলোড করুন',
    photoId: 'ফটো আইডি',
    resubmit: 'আবার জমা দিন',
    limit: 'প্রতিদিন $5,000',
    uploading: 'আপলোড হচ্ছে...',
    notUploadProofToast: 'অনুগ্রহ করে আইডি কার্ডের একটি প্রমাণ আপলোড করুন'
  },
  fullyVerified: {
    frontOfId: 'আইডির সামনের দিক',
    backOfId: 'আইডির পিছনের দিক',
    uploadIdFront: 'আইডির সামনের দিক আপলোড করুন',
    uploadIdBack: 'আইডির পিছনের দিক আপলোড করুন',
    withdrawDailyHint: 'উত্তোলনের জন্য তথ্য পূরণ করুন > {0} প্রতিদিন।',
    notUploadIdToast: 'আইডির সামনে ও পিছন আপলোড করুন',
    proofTitle: 'আবাসিক দলিলের প্রমাণ',
    acceptableProof: 'বসবাসের একটি গ্রহণযোগ্য প্রমাণ হল:',
    acceptableProof1: 'একটি ব্যাঙ্ক অ্যাকাউন্ট স্টেটমেন্ট।',
    acceptableProof2: 'একটি ইউটিলিটি বিল (বিদ্যুৎ, পানি, ইন্টারনেট, ইত্যাদি)।',
    acceptableProof3: 'একটি সরকার-প্রদত্ত নথি (ট্যাক্স স্টেটমেন্ট, রেসিডেন্সির শংসাপত্র, ইত্যাদি)।',
    unacceptableProof:
      'আমরা আপনার জমা দেওয়া পরিচয় নথিতে থাকা ঠিকানাটিকে বসবাসের বৈধ প্রমাণ হিসাবে গ্রহণ করতে পারি না।',
    limit: 'প্রতিদিন $10,000',
    notUploadToast: 'অনুগ্রহ করে বসবাসের নথির প্রমাণ আপলোড করুন',
    incorrectFormatToast: 'দয়া করে jpg/png/jpeg ছবি আপলোড করুন।'
  },
  loginAndRegister: {
    pwd: 'পাসওয়ার্ড',
    lastLogin: 'শেষ লগইন',
    moreOptions: 'আরও বিকল্প',
    agreeCheckboxContent: '{0} এবং {1} এর সাথে সম্মত',
    userAgreement: 'ব্যবহারকারী চুক্তি',
    privacyPolicy: 'গোপনীয়তা নীতি',
    notAgreeToast: 'ব্যবহারকারী চুক্তি এবং গোপনীয়তা নীতিতে সম্মত হন',
    forgotPassword: 'পাসওয়ার্ড ভুলে গেছি',
    linkedMail: 'লিঙ্কড মেইল',
    verificationCode: 'যাচাইকরণ কোড',
    newPwd: 'নতুন পাসওয়ার্ড',
    repeatPwd: 'পাসওয়ার্ড পুনরাবৃত্তি করুন',
    confirmPwd: 'পাসওয়ার্ড নিশ্চিত করুন',
    noLinkedEmailToast: 'আপনার অ্যাকাউন্টের সাথে কোনো লিঙ্ক করা ইমেল নেই',
    unregisteredToast: 'এই নম্বর নিবন্ধিত করা হয় নি',
    pwdFormatToast: 'পাসওয়ার্ডের বিন্যাস ভুল',
    resetSuccessToast: 'সফলভাবে \n পুনরায় সেট করুন৷',
    pwdNotMatchToast: 'দুইবার পাসওয়ার্ড মেলে না',
    emailFormatToast: 'ভুল ইমেল বিন্যাস',
    phoneNumberFormatToast: 'ভুল ফোন নম্বর বিন্যাস',
    invalidAreaCodeToast: 'অবৈধ এরিয়া কোড',
    login: 'লগ ইন করুন',
    pwdLogin: 'পাসওয়ার্ডের মাধ্যমে লগ ইন করুন',
    emailCodeLogin: 'ইমেল যাচাইকরণ কোডের মাধ্যমে লগ ইন করুন',
    smsLogin: 'এসএমএসের মাধ্যমে লগ ইন করুন',
    verifyEmail: 'ইমেল যাচাই করুন',
    verifyPhone: 'ফোন যাচাই করুন',
    accountDangerDialog:
      'আপনার অ্যাকাউন্ট বিপদ সনাক্ত করা হয়েছে. অনুগ্রহ করে আপনার অ্যাকাউন্ট পুনরায় যাচাই করুন, অন্যথায় আপনার অ্যাকাউন্ট ব্যবহার করা চালিয়ে যেতে সক্ষম হবে না।',
    sendEmailCodeDialog: 'আমরা আপনার {0} ইমেলে একটি যাচাইকরণ কোড পাঠিয়েছি। যাচাইকরণ কোড লিখুন.',
    sendSmsCodeDialog: 'আমরা আপনার {0} ফোনে একটি যাচাইকরণ কোড পাঠিয়েছি। যাচাইকরণ কোড লিখুন.',
    graphicCodeEmptyToast: 'গ্রাফিক কোড লিখুন.',
    countryUnselectToast: 'প্রথমে আপনার দেশ চয়ন করুন',
    unsupportedLoginTypeToast: 'অসমর্থিত লগইন প্রকার',
    pwdWrongLimitOverDialog:
      'ভুল পাসওয়ার্ড 3 বার প্রবেশ করা হয়েছে. লগ ইন করতে দয়া করে এসএমএস যাচাইকরণ কোড ব্যবহার করুন৷',
    loginFailedToast: 'লগইন ব্যর্থ হয়েছে',
    signIn: 'সাইন ইন করুন',
    pwdPlaceholder: 'পাসওয়ার্ড দিন',
    pwdNote: '৮-১৬টি অক্ষর লিখুন, বর্ণ ও সংখ্যা অন্তর্ভুক্ত করুন',
    reenterPwdPlaceholder: 'পাসওয়ার্ড পুনরায় লিখুন',
    reenterPwdNote: 'অনুগ্রহ করে পাসওয়ার্ডটি পুনরায় লিখুন',
    createAccount: 'অ্যাকাউন্ট তৈরি করুন',
    chooseCountryNote: 'দেশ নির্বাচন করুন',
    pwdInconsistentToast: 'আপনার দেওয়া আগের পাসওয়ার্ডের সাথে একই রকম নয়',
    createSuccessToast: 'সফলভাবে \n তৈরি করুন৷',
    registerFailToast: 'নিবন্ধন ব্যর্থ হয়েছে',
    userNotExistToast: 'ব্যবহারকারীর অস্তিত্ব নেই',
    phoneIncorrectToast: 'আপনার ফোন চেক করুন',
    userExistToast: 'ব্যবহারকারী ইতিমধ্যেই বিদ্যমান',
    countryCodeRepeatToast: 'বারবার দেশের কোড লিখবেন না দয়া করে!',
    logoutDialog: 'আপনি লগ আউট করতে নিশ্চিত?',
    pwdRequirement: 'অক্ষর এবং সংখ্যা সহ পাসওয়ার্ড কমপক্ষে 8 থেকে 16 অক্ষরের হতে হবে',
    signup: 'সাইন আপ করুন',
    registerSuccessToast: 'সফলভাবে \n নিবন্ধন করুন৷',
    oldPwdErrorToast: 'আপনার পুরানো পাসওয়ার্ড চেক করুন'
  },
  checkUserInfo: {
    title: 'ব্যবস্থাপনা কেন্দ্র',
    emptyInfoNote:
      'এখানে বর্তমান অ্যাকাউন্টের জন্য কোন তথ্য নেই, দয়া করে আপনার যাচাই করতে প্রয়োজনীয় MetWallet অ্যাকাউন্টটি পরীক্ষা করুন।',
    infoNote: 'এখানে আপনার যাচাইকরণ তথ্য.',
    lastSuccessWithdrawal: 'শেষ সফল প্রত্যাহার',
    copyBtn: 'অনুলিপি',
    successToast: 'সফলভাবে অনুলিপি করা হয়েছে!',
    failToast: 'কপি করতে ব্যর্থ!'
  },
  country: {
    title: 'অঞ্চল নির্বাচন করুন',
    popular: 'জনপ্রিয়'
  },
  documentDetails: {
    title: 'নথির বিবরণ',
    contract: 'চুক্তি',
    goToSign: 'সাইন ইন করতে যান',
    download: 'ডাউনলোড করুন',
    upload: 'আপলোড করুন',
    fileTypeLimit: 'ডক।, পিডিএফ।, xlsx।, xls।, png।, jpg।, jpeg।, শুধুমাত্র ডকুমেন্ট।',
    contentEmptyToast: 'বিষয়বস্তু লিখুন',
    placeOfBirth: 'জন্মস্থান',
    occupation: 'পেশা',
    fileForm: '(ফাইল ফর্ম)',
    proofOfAddress: 'ইংরেজিতে ঠিকানার প্রমাণ',
    residenceDoc: 'বাসস্থানের নথি',
    textForm: '(টেক্সট ফর্ম)',
    contractAgent: 'কন্ট্রাক্ট এজেন্ট',
    contractPayslip: 'চুক্তি পেস্লিপ',
    uncompletedToast: 'জমা দিতে এটি সম্পূর্ণ করুন',
    successToast: 'সফলভাবে জমা দিন',
    undefinedFileTypeToast: 'অনির্ধারিত ফাইল আপলোড প্রকার',
    uploadFailToast: 'আপলোড ব্যর্থ হয়েছে'
  },
  filters: {
    amount: 'পরিমাণ',
    filter: 'ফিল্টার',
    time: 'সময়',
    reset: 'রিসেট করুন',
    timePickerTitle: '{0} সময় নির্বাচন করুন',
    start: 'শুরু করুন',
    end: 'শেষ',
    maximum: 'সর্বোচ্চ',
    minimum: 'সর্বনিম্ন'
  },
  home: {
    balance: 'ভারসাম্য',
    transactions: 'লেনদেন',
    availableBalance: 'উপলভ্য ব্যালেন্স',
    noWithdrawalMethodToast: 'অন্তত একটি প্রত্যাহার পদ্ধতি প্রয়োজন.',
    linkAccount: 'অ্যাকাউন্ট লিঙ্ক করুন',
    all: 'সব',
    cashIn: 'ক্যাশ ইন',
    loading: 'লোড হচ্ছে...',
    noMore: 'আর কোনো লেনদেন নেই',
    reload: 'লোডিং ব্যর্থ হয়েছে, পুনরায় লোড করতে ক্লিক করুন৷',
    receivedFrom: 'থেকে প্রাপ্ত',
    transferredTo: 'বদলি করা হয়েছে',
    fee: 'ট্রান্সফার করার জন্য ফি',
    myEmail: 'আমার ইমেইল',
    myPhone: 'আমার ফোন',
    invalidBasicLevelDialog:
      'আপনার নামের ক্ষেত্রে চিহ্ন, স্পেস বা সংখ্যা অন্তর্ভুক্ত করার কারণে, অ্যাকাউন্ট থেকে টাকা তোলা সম্ভব নয়। অনুগ্রহ করে আবার মৌলিক তথ্য পূরণ করুন (নিশ্চিত করুন যে নামটিতে চিহ্ন, স্পেস, বা সংখ্যা অন্তর্ভুক্ত নেই এবং যদি আপনার কোন পরিবার বা মধ্যম নাম না থাকে তবে এটি খালি রাখুন।)',
    lackLastNameDialog: 'আপনার শেষ নামটি পূরণ করা হয়নি, যা আপনার প্রত্যাহারকে বাধা দেবে।',
    fillIn: 'পূরণ করুন',
    viewDetails: 'বিস্তারিত দেখুন',
    docReviewingDialogTitle: 'নথি পাস হওয়ার জন্য অনুগ্রহ করে অপেক্ষা করুন।',
    docReviewingDialogContent:
      'আপনি নথিটি জমা দিয়েছেন, কিন্তু আপনার নথি পাস হওয়ার আগে আপনি MetWallet ব্যবহার করতে পারবেন না৷<br>অফিসিয়াল কর্মীরা শীঘ্রই এটি প্রক্রিয়া করবে, অনুগ্রহ করে কিছুক্ষণ অপেক্ষা করুন৷',
    docPassedDialog: 'আপনার জমা দেওয়া নথি পাস করা হয়েছে। <br>আপনি এখন সাধারণভাবে MetWallet ব্যবহার করতে পারেন।',
    docUnqualifiedDialog: 'আপনার জমা দেওয়া নথিটি অযোগ্য। <br>দয়া করে একটি যোগ্য জমা দিন।',
    goToSubmit: 'যাও জমা দাও',
    uncompletedDialog: 'MetWallet স্বাভাবিকভাবে ব্যবহার করার জন্য আপনাকে অবশ্যই এটি সম্পূর্ণ করতে হবে',
    useMetWalletNormallyAfterPassed: 'নথি পাস করার পরে আপনি সাধারণত MetWallet ব্যবহার করতে পারেন।',
    requireSemiVerifiedDialog:
      '{0}, ব্যাঙ্কের প্রয়োজনে, সফলভাবে উত্তোলনের জন্য আপনাকে 48 ঘণ্টার মধ্যে আধা-যাচাইকৃত অংশ শেষ করতে হবে।',
    goToVerify: 'যাচাই করতে যান',
    emailInvalidDialog:
      '{0}, আপনার ই-মেইল ঠিকানা অন্য ব্যক্তির মতই। গোপনীয়তা বীমার জন্য, যত তাড়াতাড়ি সম্ভব আপনার নিজের ই-মেইল ঠিকানা লিখুন।',
    later: 'পরে',
    transferRequireSemiVerifiedDialog: 'স্থানান্তর করার আগে অনুগ্রহ করে আধা-যাচাইকৃত যাচাইকরণ সম্পূর্ণ করুন।',
    modifyBtnText: 'আমার তথ্য পরিবর্তন করুন',
    unmodifiedTitle: 'পরিবর্তন করতে অক্ষম',
    unmodifiedContent: 'আপনার একটি উত্তোলন অর্ডার প্রক্রিয়াধীন রয়েছে। এখন তথ্য পরিবর্তন করা যাবে না।'
  },
  signing: {
    signature: 'স্বাক্ষর',
    date: 'তারিখ',
    employeeName: 'কর্মচারীর নাম',
    designation: 'পদবী',
    month: 'মাস',
    year: 'বছর',
    earnings: 'আয়',
    deductions: 'কর্তন',
    basic: 'বেসিক এবং DA(USD)',
    totalAddition: 'মোট সংযোজন',
    totalDeduction: 'মোট ডিডাকশন',
    salary: 'NET বেতন',
    refNo: 'রেফারেন্স নং',
    paymentTransferDate: 'পেমেন্ট ট্রান্সফারের তারিখ',
    nameOfBank: 'ব্যাংকের নাম',
    signatureOfEmployee: 'কর্মচারীর স্বাক্ষর',
    director: 'পরিচালক',
    signNote: 'আপনার নাম স্বাক্ষর করুন',
    preview: 'পূর্বরূপ',
    clear: 'পরিষ্কার',
    save: 'সংরক্ষণ করুন',
    noSignatureToast: 'আপনি একটি স্বাক্ষর ছাড়া সংরক্ষণ করতে পারবেন না.',
    fieldEmptyToast: 'সব তথ্য পূরণ করুন.'
  },
  transactionDetail: {
    title: 'লেনদেনের বিবরণ',
    status: 'স্ট্যাটাস',
    pending: 'মুলতুবি',
    completed: 'সম্পন্ন',
    success: 'সফলতা',
    failed: 'ব্যর্থ হয়েছে',
    cancelled: 'বাতিল',
    onHold: 'হোল্ডে',
    reason: 'স্থিতির কারণ',
    description: 'বর্ণনা',
    creationDate: 'সৃষ্টির তারিখ',
    lastStatusDate: 'সর্বশেষ অবস্থা তারিখ',
    requestedAmount: 'অনুরোধ করা পরিমাণ',
    receiveAmount: 'পরিমাণ গ্রহণ',
    transferAmount: 'স্থানান্তর পরিমাণ',
    amountToPay: 'পরিশোধের পরিমাণ',
    transferFee: 'স্থানান্তর ফি',
    processingFee: 'প্রসেসিং ফি',
    method: 'পদ্ধতি',
    country: 'দেশ',
    name: 'নাম',
    bankPendingText: 'চূড়ান্ত ব্যাংক রিভিউ অধীন',
    pendingText: '{0} রিভিউ অধীন',
    chametSalary: 'চামেট বেতন',
    userSalary: 'ব্যবহারকারীর বেতন',
    comm: 'যোগাযোগ।',
    gemgalaSalary: 'জেমগালা বেতন'
  },
  transfer: {
    title: 'মেটওয়ালেট অ্যাকাউন্টে',
    noPayPwdDialog: 'স্থানান্তর করার আগে অনুগ্রহ করে একটি 6-সংখ্যার পেমেন্ট পাসওয়ার্ড সেট করুন।',
    records: 'রেকর্ডস',
    cashInOut: 'নগদ {0} এ, ক্যাশ আউট {1}',
    transfer: 'স্থানান্তর',
    fee: 'ফি',
    remark: 'মন্তব্য',
    transferTo: '{0} এ স্থানান্তর করুন',
    remarkPlaceholder: 'স্থানান্তর মন্তব্য যোগ করুন (কম 100 অক্ষর)',
    firstNameNote: 'অনুগ্রহ করে তার নাম লিখুন',
    sendingAmount: 'পাঠানোর পরিমাণ',
    receivingAmount: 'প্রাপ্তির পরিমাণ',
    transferNow: 'এখনই স্থানান্তর করুন',
    noBalanceToast: 'ট্রান্সফারের পরিমাণ ব্যালেন্স পরিমাণের চেয়ে বড়।',
    amountTooLittleToast: 'স্থানান্তরের পরিমাণ $10 এর কম হতে পারে না।'
  },
  bankData: {
    beneficiaryName: 'সুবিধাভোগীর নাম',
    beneficiaryNamePlaceholder: 'নাম লিখুন',
    beneficiaryLastname: 'সুবিধাভোগী পদবি',
    beneficiaryLastnamePlaceholder: 'শেষ নাম লিখুন',
    bankCode: 'ব্যাঙ্ক কোড',
    bankCodePlaceholder: 'ব্যাঙ্ক কোড নির্বাচন করুন',
    bankIFSCCode: 'ব্যাঙ্ক IFSC কোড',
    bankIFSCCodePlaceholder: 'ব্যাঙ্ক IFSC লিখুন',
    bankAccount: 'ব্যাঙ্ক অ্যাকাউন্ট',
    bankAccountPlaceholder: 'ব্যাঙ্ক অ্যাকাউন্ট লিখুন',
    email: 'ইমেইল',
    emailPlaceholder: 'ইমেইল লিখুন',
    phoneNumber: 'ফোন নম্বর',
    phoneNumberPlaceholder: 'ফোন নম্বর লিখুন',
    address: 'ঠিকানা',
    addressPlaceholder: 'ঠিকানা লিখুন',
    city: 'শহর',
    cityPlaceholder: 'শহরে প্রবেশ করুন',
    state: 'রাজ্য',
    statePlaceholder: 'রাজ্যে প্রবেশ করুন',
    postCode: 'পোস্ট কোড',
    postCodePlaceholder: 'পোস্ট কোড লিখুন',
    documentId: 'ডকুমেন্ট আইডি',
    documentIdPlaceholder: 'ডকুমেন্ট আইডি লিখুন',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'নথির ধরন',
    documentTypePlaceholder: 'ডকুমেন্ট টাইপ নির্বাচন করুন',
    accountType: 'অ্যাকাউন্টের ধরন',
    accountTypePlaceholder: 'অ্যাকাউন্টের ধরন নির্বাচন করুন',
    cpfcnpjPlaceholder: 'CPFCNPJ লিখুন',
    bankBranch: 'ব্যাংক শাখা',
    bankBranchPlaceholder: 'ব্যাংক শাখায় প্রবেশ করুন',
    ribOfBankAccount: 'ব্যাঙ্ক অ্যাকাউন্টের RIB',
    bankName: 'ব্যাঙ্কের নাম',
    bankNamePlaceholder: 'ব্যাঙ্কের নাম লিখুন',
    bicCode: 'BIC কোড',
    bicCodePlaceholder: 'BIC কোড লিখুন',
    ibanPlaceholder: 'IBAN লিখুন',
    bankSwift: 'ব্যাংক সুইফট',
    bankSwiftPlaceholder: 'ব্যাংক সুইফটে প্রবেশ করুন',
    name: 'নাম',
    documentCountry: 'নথির দেশ',
    documentCountryPlaceholder: 'নথির দেশ নির্বাচন করুন',
    issueDate: 'ডকুমেন্ট ইস্যু তারিখ',
    issueDatePlaceholder: 'ইস্যু তারিখ নির্বাচন করুন',
    expireDate: 'নথির মেয়াদ শেষ হওয়ার তারিখ',
    expireDatePlaceholder: 'মেয়াদ শেষ হওয়ার তারিখ নির্বাচন করুন',
    bankBranchName: 'ব্যাংক শাখার নাম',
    bankBranchNamePlaceholder: 'শাখার নাম লিখুন',
    branchPlaceholder: 'শাখায় প্রবেশ করুন',
    gender: 'লিঙ্গ',
    genderPlaceholder: 'লিঙ্গ নির্বাচন করুন',
    birthday: 'জন্মদিন',
    birthdayPlaceholder: 'জন্মদিন নির্বাচন করুন',
    phone: 'ফোন',
    bankAddress: 'ব্যাঙ্কের ঠিকানা',
    bankAddressPlaceholder: 'ব্যাঙ্কের ঠিকানা লিখুন',
    bankAccountName: 'ব্যাঙ্ক অ্যাকাউন্টের নাম',
    bankAccountNamePlaceholder: 'ব্যাঙ্ক অ্যাকাউন্টের নাম লিখুন',
    province: 'প্রদেশ',
    provincePlaceholder: 'প্রদেশে প্রবেশ করুন',
    postalCode: 'পোস্টাল কোড',
    postalCodePlaceholder: 'পোস্টাল কোড লিখুন',
    savingsAccount: 'সেভিংস অ্যাকাউন্ট',
    abaRoutingNumber: 'ABA রাউটিং নম্বর',
    englandBankAccount: 'ইংল্যান্ড ব্যাঙ্ক অ্যাকাউন্ট',
    bankBranch2: 'ব্যাংক শাখা',
    bankBranch2Placeholder: 'শুধুমাত্র যদি ব্যাঙ্ক Santander হয়',
    paternalName: 'পৈতৃক নাম',
    paternalNamePlaceholder: 'পৈতৃক নাম লিখুন',
    passportIdNumber: 'পাসপোর্ট আইডি নম্বর',
    bankNamePlaceholder2: 'ব্যাঙ্কের নাম নির্বাচন করুন',
    areaCode: 'এলাকার কোড',
    phoneNumberNoAreaCode: 'ফোন নম্বর (কোন এরিয়া কোড নেই)',
    idType: 'আইডি টাইপ',
    idNo: 'আইডি নম্বর',
    idIssueDate: 'আইডি ইস্যু তারিখ',
    idExpireDate: 'আইডি মেয়াদ শেষ হওয়ার তারিখ',
    ibanStyleToast: "অনুগ্রহ করে 'SA' দিয়ে শুরু হয় এমন 24টি অক্ষরের বিষয়বস্তু লিখুন।"
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'আপনি শুধুমাত্র ডায়মন্ড বিক্রেতাদের কাছে স্থানান্তর করতে পারেন৷',
    search: 'অনুসন্ধান করুন',
    history: 'স্থানান্তরিত ব্যবহারকারী',
    confirm_content: 'আপনি কি {0} থেকে {1} এ স্থানান্তর করার বিষয়ে নিশ্চিত',
    success_content: '{0}কে {1} এ স্থানান্তর করা হয়েছে',
    purchase: 'ক্রয়',
    purchase_success: 'আপনি সফলভাবে ক্রয় করেছেন {0}',
    insufficient_balance: 'অপর্যাপ্ত ভারসাম্য',
    purchase_diamond: 'হীরা কিনুন',
    transfer_limit_2: 'স্থানান্তরের পরিমাণ $10 এবং $30,000 এর মধ্যে হওয়া উচিত',
    no_data: 'কোন ডেটা নেই',
    invalid_number: 'একটি বৈধ নম্বর লিখুন',
    under_limit: 'স্থানান্তরের পরিমাণ $10 এর কম হওয়া উচিত নয়',
    over_limit: 'স্থানান্তরের পরিমাণ $30,000 এর কম হওয়া উচিত'
  },
  redesign: {
    emailPlaceholder: 'ইমেল ঠিকানা লিখুন',
    retrievePwd: 'পাসওয়ার্ড পুনরুদ্ধার করুন',
    resetPwd: 'পাসওয়ার্ড রিসেট করুন',
    newPwdPlaceholder: 'নতুন পাসওয়ার্ড লিখুন',
    reenterNewPwdPlaceholder: 'নতুন পাসওয়ার্ড পুনরায় লিখুন',
    reenterPayPwdPlaceholder: 'অনুগ্রহ করে অর্থপ্রদানের পাসওয়ার্ড পুনরায় লিখুন',
    sendToPhone: 'আপনার ফোনে যাচাইকরণ কোড পাঠানো হয়েছে',
    sendToWhatsapp: 'যাচাইকরণ কোডটি আপনার WhatsApp এ পাঠানো হয়েছে',
    sendToEmail: 'যাচাইকরণ কোড আপনার ইমেল পাঠানো হয়েছে',
    invalidCode: 'অবৈধ কোড',
    userId: 'ইউজার আইডি',
    other: 'অন্যান্য',
    transactionRecord: 'লেনদেন রেকর্ড',
    bankCardInfo: 'ব্যাঙ্ক কার্ড অ্যাকাউন্ট',
    withdrawInfo: 'প্রত্যাহার অ্যাকাউন্ট',
    toFillIn: 'পূরণ করতে হবে',
    walletInfo: 'ওয়ালেট অ্যাকাউন্ট তথ্য',
    toComplete: 'সম্পন্ন করা',
    verifyGuide: 'আরও উত্তোলনের যোগ্যতা পেতে ওয়ালেট অ্যাকাউন্টের তথ্য সম্পূর্ণ করুন',
    verifyNote: '{0} এর দৈনিক উত্তোলনের যোগ্যতা পেতে নিম্নলিখিত তথ্যটি সম্পূর্ণ করুন',
    verifyCompletedNote: '{0} এর দৈনিক প্রত্যাহারের যোগ্যতা অর্জনের জন্য তথ্য সম্পূর্ণ হয়েছে',
    continueBtnText: 'পূরণ করা চালিয়ে যান',
    submitInfo: 'তথ্য জমা দিন',
    transferAmount: 'স্থানান্তর পরিমাণ',
    newEmailVerify: 'নতুন ইমেল যাচাইকরণ',
    verifyCodePlaceholder: 'যাচাইকরণ কোড লিখুন',
    emailIncorrectToast: 'সঠিক ইমেল ঠিকানা লিখুন',
    newPhone: 'নতুন ফোন নম্বর',
    accountAdded: 'অ্যাকাউন্ট তথ্য যোগ করা হয়েছে',
    accountToAdd: 'অন্যান্য অ্যাকাউন্ট যোগ করা যেতে পারে',
    edit: 'সম্পাদনা করুন',
    enterPayPwd: 'পেমেন্ট পাসওয়ার্ড লিখুন',
    deleteBtnText: 'মুছে দিন',
    transferTo: 'ট্রান্সফার করুন',
    withdrawable: 'প্রত্যাহারযোগ্য',
    goSet: 'সেটে যান',
    goModify: 'পরিবর্তন করতে যান'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/bn.js